'use client'

import { useEffect } from 'react'
import useEvent from '@/hooks/useEvent'
import { isPageScrolledStore, isSidebarScrolledStore, visibleClausesStore } from '../Law/Clause/scroll-store'

export function Content ({ children }) {
  const handleOnLoadData = useEvent(function (): void {
    if (window.location.hash) {
      const elem = document.getElementById(window.location.hash.slice(1))
      elem?.scrollIntoView()
    }
  })

  useEffect(() => {
    handleOnLoadData()

    return () => {
      isPageScrolledStore.set(false)
      isSidebarScrolledStore.set(false)
      visibleClausesStore.set(new Set<number>())
    }
  }, [handleOnLoadData])

  return children
}
